import { RouterModule } from '@angular/router';
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { IndexComponent } from './index/index.component';
import { TranslateModule } from '@ngx-translate/core';
import { ShareDetailModule } from 'src/app/detail/share-detail.module';
import { NgxJsonLdModule } from 'ngx-json-ld';
import { SwiperModule } from 'src/app/swiper/swiper.module';
import { ShareCmsModule } from 'src/app/share-cms/share-cms.module';
import { TechmoreSharedModule } from '@techmore/share';



@NgModule({
  declarations: [IndexComponent],
  imports: [
    CommonModule,
    TranslateModule.forChild(),
    ShareDetailModule,
    SwiperModule,
    NgxJsonLdModule,
    ShareCmsModule,
    TechmoreSharedModule,
    RouterModule
  ],
  entryComponents: [IndexComponent]
})
export class CmsSingle01Module {
  static entry = IndexComponent;
}
